import { useTranslation } from 'react-i18next';

export default function WhyChooseUs() {
  const { t } = useTranslation();
  const benefits = [
    { icon: 'ri-shield-check-line', color: 'from-emerald-500 to-teal-500', titleKey: 'why.b1_title', descKey: 'why.b1_desc' },
    { icon: 'ri-flashlight-line', color: 'from-orange-500 to-pink-500', titleKey: 'why.b2_title', descKey: 'why.b2_desc' },
    { icon: 'ri-price-tag-3-line', color: 'from-yellow-500 to-amber-500', titleKey: 'why.b3_title', descKey: 'why.b3_desc' },
    { icon: 'ri-film-line', color: 'from-[#0284c7] to-[#0ea5e9]', titleKey: 'why.b4_title', descKey: 'why.b4_desc' },
    { icon: 'ri-customer-service-2-line', color: 'from-cyan-500 to-blue-500', titleKey: 'why.b5_title', descKey: 'why.b5_desc' },
  ];
  return (
    <section className="py-10 md:py-20 bg-gradient-to-b from-background via-background to-primary/5 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#0ea5e9]/10 rounded-full blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-8 md:mb-16 animate-fade-in">
          <span className="inline-block px-4 py-1 bg-primary/10 text-primary rounded-full text-sm font-semibold mb-3 md:mb-4">{t('why.badge')}</span>
          <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto">{t('why.desc')}</p>
        </div>
        <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-center">
          <div className="relative group animate-fade-in">
            <div className="absolute inset-0 bg-gradient-to-r from-[#0284c7]/20 to-[#0ea5e9]/20 rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500" />
            <div className="relative rounded-3xl overflow-hidden">
              <img src="https://onetvservices.me/benefits-hero-Dr22Nijq.png" alt="Premium Service" className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500" loading="lazy" />
            </div>
            <div className="absolute -bottom-4 md:-bottom-6 -left-4 md:-left-6 bg-gradient-to-br from-[#0284c7] via-[#0ea5e9] to-[#0369a1] text-white rounded-xl md:rounded-2xl px-4 py-3 md:px-8 md:py-6 hover:scale-105 transition-transform duration-300">
              <div className="text-center">
                <div className="text-[10px] md:text-xs font-semibold uppercase tracking-wider mb-1">{t('why.exp')}</div>
                <div className="text-2xl md:text-4xl font-bold">{t('why.exp_val')}</div>
              </div>
            </div>
          </div>
          <div className="grid gap-3 md:gap-6">
            {benefits.map(({ icon, color, titleKey, descKey }) => (
              <div key={titleKey} className="group bg-card/50 backdrop-blur-sm border border-border/50 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-primary/50 transition-all duration-300 animate-fade-in">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl bg-gradient-to-br ${color} p-2.5 md:p-3 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${icon} text-white text-base`} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base md:text-xl font-bold mb-1 md:mb-2 group-hover:text-primary transition-colors text-white">{t(titleKey)}</h3>
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed">{t(descKey)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
